import { useQuery } from "@tanstack/react-query";
import api from "../../services/api";

export const useViewTagsList = (page = 1, pageSize = 10) => { 
    return useQuery({ 
        queryKey: ['viewtags', page, pageSize], 
        queryFn: async () => { 
            const res = await api.get('/tags/list', {
            }); 
            return res.data; 
        }
     });
};  